<template>
  <div class="positionfixed">
    <Header></Header>
  <div class="pc_all FreeCreation">
    <div class="pc_all_content">
      <div
        class="FreeCreationNav animate__animated animate__fadeInDown"
        style="animation-delay: 0.2s"
      >
        <div class="FreeCreationNav_btn">
          <router-link to="/ailogo/FreeCreation/FreeCreation" class="FreeCreationNav_list font20">
            <span class="iconfont icon-chuangzuozhezhongxin"></span>自由创作
          </router-link>
          <router-link to="/ailogo/LetterLogo/LetterLogo" class="FreeCreationNav_list font20 active">
            <span class="iconfont icon-fa-buysellads"></span>字母LOGO
          </router-link>
          <router-link to="/ailogo/SameCreation/SameCreation" class="FreeCreationNav_list font20">
            <span class="iconfont icon-AItongkuan"></span>同款创作
          </router-link>
        </div>
      </div>
      <div class="LetterLogo">
        <div
          v-for="(letter, index) in letters"
          :key="index"
          class="LetterLogo_list font22 animate__animated animate__fadeInDown"
          style="animation-delay: 0.4s"
          :class="{ active: selectedLetterIndex === index }"
          @click="selectLetter(index)"
        >
          {{ letter }}
        </div>
      </div>
      <div
        v-if="isSelectIndustryVisible"
        class="LetterLogoTitle font20 animate__animated animate__fadeInDown"
        style="animation-delay: 0.2s"
      >
        请选择您<span>所属的行业</span>
      </div>

      <div v-if="isSelectIndustryVisible" class="SelectIndustry">
        <div
          v-for="(industry, index) in industries"
          :key="index"
          class="SelectIndustry_list animate__animated animate__fadeInDown"
          :style="{ animationDelay: industry.animationDelay + 's' }"
          :class="{ active: selectedIndex === index && !isOtherIndustryActive }"
          @click="selectIndustry(index)"
        >
          <div class="SelectIndustry_list_left font20">
            <div
              class="list_left_icon iconfont"
              :class="industry.icon"
              :style="{ background: industry.color }"
            ></div>
            {{ industry.name }}
          </div>
          <div class="SelectIndustry_list_right"></div>
        </div>
        <div
          class="SelectIndustry_list animate__animated animate__fadeInDown"
          style="animation-delay: 2.1s"
          :class="{ active: isOtherIndustryActive }"
        >
          <div class="SelectIndustry_list_left">
            <div class="list_left_icon iconfont icon-qita" style="background: #dbe2e5"></div>
            <input
              type="text"
              placeholder="输入其他行业"
              class="font20"
              v-model="otherIndustry"
              @input="handleInput"
            />
          </div>
        </div>
      </div>
      <div class="Btn animate__animated animate__fadeInDown" style="animation-delay: 0.6s">
        <router-link
          to="/ailogo/EnterBrand/EnterBrand" class="Btn_prev font20" @click="goBack">
          <span class="iconfont icon-xiangyou"></span>上一步
        </router-link>
        <div :class="['Btn_next font20', { active: isNextActive }]" @click="goToFreeCreation">
          <div class="form_btn_po">继续<span class="iconfont icon-xiangyou"></span></div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import Header from '@c/header/header'

export default {
  data() {
    return {
      letters: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''), // 字母数组
      selectedLetterIndex: null, // 当前选中的字母索引
      isSelectIndustryVisible: false, // 控制 SelectIndustry 的显示状态
      industries: [
        { name: '餐饮美食', icon: 'icon-canyin', color: '#dacffe', animationDelay: 0.1 },
        { name: '美容美发', icon: 'icon-meirongmeifa', color: '#c0e4fc', animationDelay: 0.2 },
        { name: '健康养生', icon: 'icon-yangsheng1', color: '#fcbdcf', animationDelay: 0.3 },
        { name: '教育培训', icon: 'icon-icon-', color: '#fff2b3', animationDelay: 0.4 },
        { name: '文体娱乐', icon: 'icon-tiyu', color: '#a8f5eb', animationDelay: 0.5 },
        { name: '母婴保育', icon: 'icon-a-familyinfo', color: '#dbe2e5', animationDelay: 0.6 },
        { name: '箱包服饰', icon: 'icon-shangpin', color: '#fcbdcf', animationDelay: 0.7 },
        { name: '家居建材', icon: 'icon-sjiancai', color: '#dacffe', animationDelay: 0.8 },
        { name: '萌宠服务', icon: 'icon-chongwufuwu', color: '#a8f5eb', animationDelay: 0.9 },
        { name: '商品零售', icon: 'icon-ordericostore', color: '#dbe2e5', animationDelay: 1 },
        { name: '旅游住宿', icon: 'icon-lvyouzhusu', color: '#fff2b3', animationDelay: 1.1 },
        { name: '汽车服务', icon: 'icon-qichefuwu', color: '#fcbdcf', animationDelay: 1.2 },
        { name: '房地产', icon: 'icon-fangdichan', color: '#dbe2e5', animationDelay: 1.3 },
        { name: '科研服务', icon: 'icon-microscope-full', color: '#fff2b3', animationDelay: 1.4 },
        { name: '生产制造', icon: 'icon-shengchanzhizao', color: '#c0e4fc', animationDelay: 1.5 },
        { name: '企业服务', icon: 'icon-qiyefuwu', color: '#fcbdcf', animationDelay: 1.6 },
        { name: '农业服务', icon: 'icon-nongye', color: '#a8f5eb', animationDelay: 1.7 },
        { name: '公益环保', icon: 'icon-zhiyuanzhe0', color: '#dacffe', animationDelay: 1.8 },
        {
          name: '政务组织',
          icon: 'icon-dianzizhengwuliutong',
          color: '#c0e4fc',
          animationDelay: 1.9
        },
        { name: '生活服务', icon: 'icon-shenghuofuwu', color: '#a8f5eb', animationDelay: 2 }
      ],
      selectedIndex: null, // 当前选中的行业索引
      otherIndustry: '', // 其他行业输入框内容
      isOtherIndustryActive: false, // 控制其他行业选项的 active 状态
      isNextActive: false // 控制 Btn_next 的 active 状态
    }
  },
  components: {
    Header
  },
  methods: {
    selectLetter(index) {
      this.selectedLetterIndex = index
      this.isSelectIndustryVisible = true
      this.updateNextButtonState() // 更新“继续”按钮的状态
    },
    selectIndustry(index) {
      this.selectedIndex = index
      this.isOtherIndustryActive = false
      this.otherIndustry = ''
      this.updateNextButtonState() // 更新“继续”按钮的状态
    },
    handleInput() {
      this.isOtherIndustryActive = this.otherIndustry.trim() !== ''
      if (this.isOtherIndustryActive) {
        this.selectedIndex = null
      }
      this.updateNextButtonState() // 更新“继续”按钮的状态
    },
    updateNextButtonState() {
      this.isNextActive =
        this.selectedLetterIndex !== null &&
        (this.selectedIndex !== null || this.isOtherIndustryActive)
    },
    goToFreeCreation() {
      if (this.isNextActive) {
        this.$router.push('/ailogo/LetterLogo/Color')
      }
    },
    goBack() {
      this.$router.push({ name: 'EnterBrand' })
    }
  }
}
</script>

<style>
@import "LetterLogo.css";
</style>

